$( document ).ready(function() {


    $('.container').lightGallery({
      selector: '.zoom',
      download: false,
      counter: false
    });


})
